import { useEffect, useState } from "react";
import Button from "../components/button";
import Modal from "../components/modal";
import Input from "../components/input";
import api from "../utils/api";
import ItemReceiver from "./item-receiver";
import colors from "../components/colors";
import { isMobile } from "react-device-detect";
import Snackbar from "../components/snackbar";
import { validateReceiver } from "../utils/validators";
import { useAuthContext } from "../context/Auth";

const Receivers = () => {

    const { setReceiversOptions } = useAuthContext();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingNew, setIsLoadingNew] = useState(false);
    const [receivers, setReceivers] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [type, setType] = useState('cpf');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [document, setDocument] = useState('');
    const [snackbar, setSnackbar] = useState({ message: '', type: 'error', visible: false }); 

    const handleNew = () => {

        const error = validateReceiver({ name, email, type, document });
        if (error) {
            setSnackbar({ message: error, type: 'error', visible: true });
            return;
        }
        
        setIsLoadingNew(true);

        api.post('/receiver', {
            name,
            email,
            type,
            document
        }, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("token")
            }
        })
        .then(res => {
            setName('');
            setEmail('');
            setType('cpf');
            setDocument('');
            setIsLoadingNew(false);
            getReceivers();
            setIsModalOpen(false);
            setSnackbar({
                message: 'Recebedor cadastrado com sucesso',
                type: 'success',
                visible: true,
            });
        })
        .catch(error => {
            setIsLoadingNew(false);
            const message = error.response?.data?.message || 'Erro ao criar recebedor';
            setSnackbar({
                message,
                type: 'error',
                visible: true,
            });
        });        

    }

    const getReceivers = () => {

        setIsLoading(true);

        api.get('/receiver', {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(function (res) {
            setReceivers(res.data);
            let receiversOptionsBd = [{
                'label': '',
                'value': ''
            }];
            res.data.forEach(value => {
                receiversOptionsBd.push({
                    'label': value.name,
                    'value': value.id,
                    'type': value.type,
                });
            })
            setReceiversOptions(receiversOptionsBd);
            setIsLoading(false);
        })
        .catch(err => {
            setIsLoading(false);
        });

    }

    useEffect(() => {
        getReceivers();
    }, [])

    return(
        <>
            <div className="bg-white shadow-md rounded-lg p-6">

                <div className={`flex ${isMobile ? 'flex-col items-start gap-2' : 'justify-between items-center'}`}>
                    <h6 className="text-xl">Recebedores</h6>
                    <Button onClick={() => setIsModalOpen(true)}>Novo recebedor</Button>
                </div>

                {/* Tabela de Últimos Boletos Criados */}
                {isLoading ? (
                    <div className="animate-pulse mt-4">
                        <div className="h-6 bg-gray-300 rounded w-3/4 mb-4"></div>
                        <div className="h-6 bg-gray-300 rounded w-full mb-4"></div>
                        <div className="h-6 bg-gray-300 rounded w-2/3"></div>
                    </div>
                ) : (
                    <div className="overflow-x-auto w-full">
                        <table className="min-w-full mt-4 table-auto border-collapse">
                            <thead>
                                <tr className="border-b">
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Nome</th>
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">E-mail</th>
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Documento</th>
                                    {/* <th></th> */}
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {receivers?.map((receiver, index) => (
                                    <ItemReceiver receiver={receiver} key={index} getReceivers={getReceivers} />
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

            </div>

            <Modal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                title="Novo recebedor"
            >

                <div className="mb-4">
                    <Input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        label="Nome completo"
                        fullWidth
                        type="text"
                        placeholder="Nome completo do recebedor"
                    />
                </div>

                <div className="mb-4">
                    <Input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        label="E-mail"
                        fullWidth
                        type="text"
                        placeholder="E-mail do recebedor"
                    />
                </div>

                <div className="mb-4">
                    <Input
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                        fullWidth
                        label="Tipo de pessoa"
                        type="select"
                        options={[
                            { value: 'cpf', label: 'Pessoa física' },
                            { value: 'cnpj', label: 'Pessoa jurídica' },
                        ]}
                    />
                </div>

                <div className="mb-4">
                    <Input
                        type={type}
                        value={document}
                        onChange={(e) => setDocument(e.target.value)}
                        label={type == 'cpf' ? 'CPF' : 'CNPJ'}
                        fullWidth
                        placeholder="Documento do recebdor"
                    />
                </div>

                {type === 'cnpj' && (
                    <div
                        className="text-sm px-4 py-2 mb-4 rounded-[8px] border"
                        style={{
                        backgroundColor: `${colors.primary}20`, // cor com opacidade
                        color: colors.primary,
                        borderColor: colors.primary,
                        }}
                    >
                        A transferência para CNPJ possui uma taxa de R$ 2,00 descontada do valor líquido do split.
                    </div>
                )}

                <div
                    className="text-sm px-4 py-2 mb-4 rounded-[8px] border"
                    style={{
                    backgroundColor: `${colors.primary}20`, // cor com opacidade
                    color: colors.primary,
                    borderColor: colors.primary,
                    }}
                >
                    O recebedor terá um convite enviado no e-mail para acessar a LucroTech e verificar recebimentos. A primeira senha é o próprio e-mail.
                </div>

                <Button
                    disabled={!type || !email || !name || !document}
                    fullWidth
                    isLoading={isLoadingNew}
                    onClick={handleNew}
                >
                    Salvar
                </Button>
                
            </Modal>
            {snackbar.visible && (
                <Snackbar
                    message={snackbar.message}
                    type={snackbar.type}
                    onClose={() => setSnackbar({ ...snackbar, visible: false })}
                />
            )}
        </>
    )
}

export default Receivers;